module.exports = __webpack_public_path__ + "entry-logged-out-48909c19/discovered-background-wide-448090456338c27920781a78ddabfae5.svg";